import { useTranslation } from "react-i18next";
import cardImage from "../assets/card.png";

export const PromoBannerMobile = () => {
  const { t } = useTranslation();

  return (
    <div className="mx-5 rounded-lg bg-background-neutral py-4">
      <p className="typography-extra-small-text-medium text-center text-text-neutral-subtler">
        {t("payment.mobile.offer.title")}
      </p>

      <p className="typography-regular-text-semibold mx-5 mt-1 text-center text-text-neutral">
        {t("payment.mobile.offer.description")}
      </p>
      <img
        className="mx-auto mt-3 block w-[196px]"
        src={cardImage}
        alt="card"
      />
    </div>
  );
};
